import axios from "axios";
import { TENANT_SLUG_HEADER, getTenantSlug } from "./tenant";

const whitelabelApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    Accept: "application/json",
    "X-Origin": "WEB",
    "X-Platform": "web",
  },
});

whitelabelApi.interceptors.request.use((config) => {
  const tenantSlug = getTenantSlug();

  if (tenantSlug) {
    config.headers[TENANT_SLUG_HEADER] = tenantSlug;
  }

  return config;
});

export default whitelabelApi;
